import { ref } from 'vue';

/**
 * "Now" for schedule views, as something they can react to.
 *
 * A schedule moves between Upcoming, Active and Expired as time passes, and
 * the Search page and its drawers stay open for hours. Views that read
 * `new Date()` inside a computed froze at their first render: a one-off that
 * ended at 14:00 still read Active, and still counted, at 15:40.
 *
 * {@link scheduleNow} returns the current time and, read inside a computed or
 * a render, makes it recompute on the next minute boundary. Schedule times
 * are whole minutes, so a minute is as fine as the state can change. One timer
 * serves the whole app, and it only starts once something reads the clock.
 */
const tick = ref(0);
let started = false;

function start(): void {
    if (started || typeof window === 'undefined') return;
    started = true;
    const untilNextMinute = 60_000 - (Date.now() % 60_000);
    setTimeout(() => {
        tick.value += 1;
        setInterval(() => {
            tick.value += 1;
        }, 60_000);
    }, untilNextMinute);
}

export function scheduleNow(): Date {
    start();
    // Read so the caller's computed depends on the minute tick.
    void tick.value;
    return new Date();
}

/** Test seam: forget the running timer, so fake timers can start a fresh one. */
export function __resetScheduleClock(): void {
    started = false;
    tick.value = 0;
}
